import type { AllowedFeatureFilterOption } from "@next-platform/client-common-core";
import type { IFilterItem } from "@next-platform/client-common-spicy-ui";
import { FilterVariant } from "@next-platform/client-common-spicy-ui";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

import { EXCLUDED_REFINEMENT_PREFIX } from "./constants";

export default function getFeatureFilterList({
  options,
  items,
  selectedRefinements,
}: {
  options: readonly AllowedFeatureFilterOption[];
  items: readonly Pick<RefinementListItem, "value" | "count">[];
  selectedRefinements: readonly string[];
}): IFilterItem[] {
  return options.flatMap(({ value, label, subtitle }) => {
    const excludedValue = `${EXCLUDED_REFINEMENT_PREFIX}${value}`;
    const isIncluded = selectedRefinements.includes(value);
    const isExcluded = selectedRefinements.includes(excludedValue);
    const matchingRefinement = items.find((candidate) => candidate.value === value);
    let variant = FilterVariant.DEFAULT;

    if (isIncluded) {
      variant = FilterVariant.INCLUDE;
    } else if (isExcluded) {
      variant = FilterVariant.EXCLUDE;
    }

    const count = matchingRefinement?.count ?? (variant === FilterVariant.DEFAULT ? 0 : null);
    if (variant === FilterVariant.DEFAULT && count === 0) {
      return [];
    }

    return [
      {
        value,
        label,
        subtitle,
        count,
        variant,
      },
    ];
  });
}
